import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar({ isLoggedIn, currentUser, onLogout }) {
  return (
    <nav className="navbar">
      <div className="navbar-row">
        <div className="navbar-left">
          <Link to="/" className="navbar-logo">
            <img src="/images/icon/swapwisehkicon.png" alt="SwapWise HK" className="logo-image" />
          </Link>
        </div>
        
        <div className="navbar-middle">
          <ul className="navbar-links">
            <li><Link to="/browse">Browse</Link></li>
            <li><Link to="/wtb">WTB</Link></li>
            <li><Link to="/repair-shops">Repair Shops</Link></li>
            <li><Link to="/ai-advisor">AI Advisor</Link></li>
          </ul>
        </div>
        
        <div className="navbar-right">
          <div className="auth-section">
            {isLoggedIn ? (
              <div className="user-welcome">
                <Link to={`/profile/${currentUser.id}`} className="welcome-link">
                  Welcome, {currentUser.username}
                </Link>
                <button onClick={onLogout} className="logout-btn">Logout</button>
              </div>
            ) : (
              <div className="auth-links">
                <Link to="/signup" className="register-link">Register</Link>
                <Link to="/login" className="login-link">Login</Link>
              </div>
            )}
          </div>
          
          <Link to="/create-listing" className="list-item-btn">List an Item</Link>
          
          <button className="language-toggle">中文 / EN</button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar; 